import Box from "@amzn/awsui-components-react-v3/polaris/box";
import Grid from "@amzn/awsui-components-react-v3/polaris/grid";
import { SelectProps } from "@amzn/awsui-components-react-v3/polaris/select";
// import the token here to test that our jest-preset handles it
import * as tokens from "@amzn/awsui-design-tokens";
import React from "react";

const cloudfrontDistributions = [{ value: "1", label: "Web delivery method" }];


// TODO: Dummy content. Needs to be updated.

// The content in the main content area of the App layout
export default function HomepageContent() {
  const [selectedOption, setSelectedOption] = React.useState<SelectProps.Option>(cloudfrontDistributions[0]);
  return (
    <>
      <div style={{ background: tokens.colorBackgroundHomeHeader }}>
        <Box padding={{ vertical: "xxl", horizontal: "s" }}>
          <Grid
            gridDefinition={[
              { offset: { l: 2, xxs: 1 }, colspan: { l: 8, xxs: 10 } },
              { colspan: { l: 5, s: 6, xxs: 10 }, offset: { l: 2, xxs: 1 } },
              { colspan: { l: 3, s: 4, xxs: 10 }, offset: { s: 0, xxs: 1 } },
            ]}
          >
            <Box padding={{ top: "xs" }} fontWeight="light">
              <span className="custom-home-text-inverted">SMT</span>
            </Box>
            <div className="custom-home-text-inverted">
              <Box variant="h1" fontWeight="bold" padding="n" fontSize="display-l" color="inherit">
                SWO UI
              </Box>
              <Box fontWeight="light" padding={{ bottom: "s" }} fontSize="display-l" color="inherit">
                System Workflow Orchestrator
              </Box>
              <Box variant="p" fontWeight="light">
                <span className="custom-home-text-secondary">
                  SWO translates a business intent of retrieving external selection information into a series of steps
                  involving SM systems and manual tasks
                </span>
              </Box>
            </div>

            </Grid>
        </Box>
      </div>

      </>
  );
}
